module.exports = __webpack_public_path__ + "static/data-engineering-banner-cce42603ad2a6dabe4d5295ccce2cc47.svg";